import React, { FC } from 'react';
import { connectSocket } from './connect-socket';
import { useDraftsLoadsContext } from '../drafts-loads/drafts-loads-context';
import { getSocket } from '../../services/socket-factory';

export const SocketListener: FC = () => {
    const { addSocketStopId, resetSocketStopIds } = useDraftsLoadsContext();

    React.useEffect(() => {
        connectSocket(addSocketStopId);

        return () => {
            resetSocketStopIds();
            getSocket().disconnect();
        };
    }, []);

    return null;
};
